import styled from '@emotion/styled';

/**
 * Tailwind's preflight resets `list-style` to `none` on `ul`/`li`, so bullets
 * must be restored explicitly here. Typography itself is handled by `UDText`
 * (isNew, type="text-1") on each `<li>`'s content, not by this component.
 */
export const BulletList = styled.ul`
  margin: 8px 0;
  padding-left: 20px;

  li {
    list-style-type: disc;
    margin-bottom: 2px;
  }
`;
